






















































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import Comentario from "@/models/comentario.model";
import BTableColumn from "@/models/base/BTableColumn.model";
import CommentService from "@/services/comment.service";

@Component
export default class Comentarios extends BaseVue {
  @Prop() readonly refEntityId!: number;
  @Prop() readonly refEntityName!: string;
  @Prop() readonly noModal!: boolean;

  lastUserId = null;
  comment: Comentario = new Comentario();
  comments: Array<Comentario> = [];
  commentService: CommentService = new CommentService();
  loading = false;
  take = 5;
  isUserModalActive = false;
  constructor() {
    super();
  }

  mounted() {
    this.getData();
  }
  onUser(comment: Comentario) {
    if(!this.noModal){
      this.isUserModalActive = true;
    }
    this.lastUserId = comment.usuario.id;
    this.$emit("onUser", this.lastUserId);
  }
  get user() {
    return this.$store.state.user;
  }
  deleteComment(comment: Comentario) {
    this.$buefy.dialog.confirm({
      title: "Confirmación",
      message: "¿Desea eliminar este comentario?",
      confirmText: "Adelante!",
      cancelText: "Cancelar",
      type: "is-danger",
      size: "is-medium",
      hasIcon: true,
      onConfirm: () => {
        this.commentService.deleteComment(comment.id).then(() => {
          this.getData();
          this.operationSuccess();
        });
      }
    });
  }
  async saveAll() {
    try {
      var result = await this.$validator.validateAll();
      if (result) {
        this.comment.usuarioId = this.user.id;
        this.comment.refEntityName = this.refEntityName;
        this.comment.refEntityId = this.refEntityId;
        this.loading = true;
        this.commentService
          .saveComment(this.comment)
          .then(() => {
            setTimeout(() => this.$validator.errors.clear(), 10);
            this.comment.init();
            this.getData();
            this.operationSuccess();
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        throw this.$validator.errors.items.map(e => e.msg);
      }
    } catch (error) {
      this.operationFailedErrors(error);
    }
  }
  getFoto(value: any) {
    return `data:image/jpg;base64, ${value}`;
  }
  getMore() {
    this.take += 5;
    this.getData();
  }
  getData() {
    this.commentService
      .getComments(this.refEntityId, this.refEntityName, this.take)
      .then(comments => {
        this.comments = comments;
      });
  }
}
